/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import ReservationSegmentEvent from '../../event/ReservationSegmentEvent'

class SegmentCategoryOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationSegmentEvent.fetch:
        return List(payload.segment_category_options)
      default:
        return state
    }
  }
}

export default new SegmentCategoryOptionsStore()
